/* @flow */
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import AdminClassesTable from 'admin/components/AdminClassesTable';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import GroupList from 'groups/components/GroupList';
import Feature from 'components/Feature';
import View from 'components/View';
import { withRouter } from 'app/context/Router';
import ORGANIZATION_QUERY from './queries/OrganizationQuery.gql';

import type { Organization_organizations } from './queries/__generated__/Organization';
import type { errorFragment } from 'queries/__generated__/errorFragment';

type Props = {
  orgId: number,
  organization: Organization_organizations,
  loading: boolean,
  error: errorFragment,
};

class AdminGroupsContainer extends React.Component<Props> {
  render() {
    const { loading, organization, orgId } = this.props;

    if (loading) {
      return <CenteredLoadingIndicator />;
    }

    return (
      <Feature
        name="classes_list.web.mar-19"
        on={<GroupList orgUuid={organization.uuid} />}
        off={
          <View scroll className="AdminGroups">
            <AdminClassesTable orgId={orgId} />
          </View>
        }
      />
    );
  }
}

const withOrganization = graphql(ORGANIZATION_QUERY, {
  skip: ({ orgId }) => !orgId,
  options: ({ orgId }) => ({
    variables: { organizationId: orgId },
  }),
  props: ({ data }) => ({
    organization: idx(data.organizations, _ => _[0]),
    loading: data.loading,
    error: data.error,
  }),
});

export { AdminGroupsContainer };

export default compose(
  withOrganization,
  withRouter
)(AdminGroupsContainer);
